// Growth Loop API client + universal activity tracker.
// Use trackEvent('view'|'save'|'share'|'search'|...) everywhere a user does
// something interesting. Anonymous users still log activity (for ranking),
// authenticated users also earn XP + badges.

const API = process.env.REACT_APP_BACKEND_URL;

const json = (r) => {
  if (!r.ok) return r.text().then((t) => { throw new Error(t || `API ${r.status}`); });
  return r.json();
};

const get = (path) => fetch(`${API}${path}`, { credentials: 'include' }).then(json);
const post = (path, body) => fetch(`${API}${path}`, {
  method: 'POST', credentials: 'include',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(body || {}),
}).then(json);

export const growth = {
  // ---- universal tracker (fire-and-forget, returns XP awarded if any) ----
  track: (payload) => {
    try {
      const body = JSON.stringify(payload);
      // sendBeacon for fast unload-safe pings; fall back to fetch for typed responses
      if (payload?.silent && navigator.sendBeacon) {
        navigator.sendBeacon(`${API}/api/activity`, new Blob([body], { type: 'application/json' }));
        return Promise.resolve({ ok: true, xp: 0, unlocked_badges: [] });
      }
      return fetch(`${API}/api/activity`, {
        method: 'POST', credentials: 'include',
        headers: { 'Content-Type': 'application/json' }, body,
      }).then(json).catch(() => ({ ok: false, xp: 0, unlocked_badges: [] }));
    } catch { return Promise.resolve({ ok: false, xp: 0, unlocked_badges: [] }); }
  },

  // ---- passport / profile ----
  myPassport:  () => get('/api/me/passport'),
  myActivity:  () => get('/api/me/activity'),
  checkin:     (listing_id, code, coords) => post('/api/me/checkin', { listing_id, code, ...(coords || {}) }),
  listingCheckins: (idOrSlug) => get(`/api/places/${encodeURIComponent(idOrSlug)}/checkins`),

  // ---- DNA preferences + recommendations ----
  getPrefs:    () => get('/api/me/preferences'),
  savePrefs:   (prefs) => post('/api/me/preferences', prefs),
  recommend:   () => get('/api/me/recommendations'),

  // ---- badges + leaderboard + public profile ----
  badges:      () => get('/api/badges'),
  leaderboard: () => get('/api/leaderboard'),
  publicUser:  (uid) => get(`/api/u/${uid}`),

  // ---- itineraries ----
  createItinerary: (data) => post('/api/itineraries', data),
  getItinerary:    (id) => get(`/api/itineraries/${id}`),
  myItineraries:   () => get('/api/me/itineraries'),
};

// Toast helpers
export const xpToast = (xp, unlocked) => {
  if (!xp && (!unlocked || !unlocked.length)) return null;
  return { xp, unlocked: unlocked || [] };
};
